export default __webpack_public_path__ + "static/media/territorial-icon.34e6892a.svg";